/**
 * Created by ShaunBetts on 23-Apr-16.
 */
import {DEVICE_TYPE_DESKTOP, DEVICE_TYPE_MOBILE} from "module/constants";

const DEVICE_WIDTH = 'deviceWidth';
const DEVICE_TYPE = 'deviceType';

// initial state
const state = {
  width: 0,
  type: null
};

//actions
const actions = {
  initState({dispatch}) {
    window.onresize = () => dispatch('deviceUpdate');
    dispatch('deviceUpdate')
  },
  deviceUpdate({commit}) {
    let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    commit(DEVICE_WIDTH, width);

    if (width <= 1024) {
      commit(DEVICE_TYPE, DEVICE_TYPE_MOBILE);
    } else {
      commit(DEVICE_TYPE, DEVICE_TYPE_DESKTOP);
    }
  }
};

//getters prawns
const getters = {
  deviceType(state) {
    return state.type;
  },
  deviceWidth(state) {
    return state.width;
  }
};

// mutations
const mutations = {
  deviceWidth(state, width) {
    state.width = width
  },
  deviceType(state, type) {
    state.type = type;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}
